import angular from 'angular';
import { CardComponent } from './card.component';

export const CardModule = angular
  .module('core.card', [])
  .component('updCard', CardComponent);
